import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { connect } from "react-redux";
import CustomModal from '../../../../../Components/Modals/CustomModal';
import ViewTaskHistory from './ViewTaskHistory';
import AddHistoryService from '../../../../../../Service/OPSServices/SWInternalServices/AddHistoryService';

import AgencyGridIdentifier from '../../../../../../../src/designUtils/Dashboard/AgencyGridIdentifier.svg'
import PartnerIconFilter from '../../../../../../../src/designUtils/Dashboard/PartnerIconFilter.svg'
import AgencyUserIconFilter from '../../../../../../../src/designUtils/Dashboard/AgencyUserIconFilter.svg'
import AgencyStorePOCIconFilter from '../../../../../../../src/designUtils/Dashboard/AgencyStorePOCIconFilter.svg'
import AgencyClientIconFilter from '../../../../../../../src/designUtils/Dashboard/AgencyClientIconFilter.svg'



function AllUsersTaskData(props) {
  const [taskName, setTaskName] = useState();
  const [taskData, setTaskData] = useState()
  const [assignedLoading, setAssingedLoading] = useState(false)
  const [openTaskTitle, setOpenTaskTitle] = useState(false)
  const [openReferencePopup,setOpenReferencePopup] = useState(false)
  const [referenceText, setReferenceText] = useState();

    const handleVivewTask = (taskData) => {
        setTaskData(taskData)
        props.setViewTaskPopup(true)
    }
    const handleViewTaskTitle = (task) => {
        setTaskName(task)
        setOpenTaskTitle(true)
      }
      const handleSubmitHistory = (e, task, flag) => {
        const value = e && e.target ? e.target.value : ""; // store value immediately
        setAssingedLoading(true);
        const formData = new FormData();
      
        if (flag === "assignedTo") {
          formData.append("assignedTo", value);
          formData.append("note", "assignedTo");
        } else {
          formData.append("assignedTo", task.assignedTo);
        }
      
        if (flag === "status") {
          formData.append("status", value);
          formData.append("note", "status");
        } else {
          formData.append("status", task.status);
        }
      
        formData.append("taskId", task.SWTeamTaskId);
        formData.append("flag", 1);
        formData.append('intId',props.store.integerID?props.store.integerID:0,)
      
        AddHistoryService(props.token, formData).then((responce) => {
          if (responce) {
            const updatedTaskList = props.alltasksToDisplay.map((t) => {
              if (t.SWTeamTaskId === task.SWTeamTaskId) {
                return flag === "assignedTo"
                  ? { ...t, assignedTo: value }
                  : { ...t, status: value };
              }
              return t;
            });
            props.setAllUsersTasks(updatedTaskList);
          }
          setAssingedLoading(false);
        });
      };
      const handleViewReference = (task) => {
        setReferenceText(task)
        setOpenReferencePopup(true)
      }

      // Filter agency members based on task's store (IntegerId)
      const getFilteredAgencyMembers = (task) => {
        if (!props.agencyMemberList || !Array.isArray(props.agencyMemberList)) {
          return [];
        }
        
        // If task has no store (IntegerId is null, 0, or undefined), show all agency members
        if (!task.IntegerId || task.IntegerId === 0) {
          return props.agencyMemberList;
        }
        
        // Filter agency members who are mapped to the task's store
        return props.agencyMemberList.filter((member) => {
          // Check if member has storeMappings array and it includes the task's IntegerId
          if (member.storeMappings && Array.isArray(member.storeMappings)) {
            return member.storeMappings.includes(task.IntegerId);
          }
          // If storeMappings is not available, include the member (fallback)
          return true;
        });
      };
    return (
        <>
            <Col md={12} >
                <div>
                    <table className="table custom-scroll-table">
                        <thead className='custom-scroll-table thead'>
                        <tr>
                                <th scope="col" className='text-center'>View</th>
                                <th scope="col" className='text-center'>Priority</th>
                                <th scope="col" className='text-center'>Title</th>
                                <th scope="col" className='text-center'>Status</th>
                                <th scope="col" className='text-center'>Assigned To</th>
                                <th scope="col" className='text-center'>Sign Off</th>
                                <th scope="col" className='text-center'>Planned Start Date</th>
                                <th scope="col"  className='text-center'>Planned End Date</th>
                                <th scope="col" className='text-center'>Created By</th>
                                <th scope="col"  className='text-center'>Completed At</th>
                                <th scope="col" className='text-center'>Reference</th>
                            </tr>
                        </thead>
                        <tbody >
                            {props.alltasksToDisplay &&
                                props.alltasksToDisplay.map((task) => (
                                    <tr key={task.SWTeamTaskId} >

                                        <td className="cursor-pointer">
                                            <div className="d-flex justify-content-center">

                                                <p className="mr-2 mb-0 d-flex justify-content-center" onClick={() => handleVivewTask(task)}>
                                                {props.accessLevel ===0 && task.accountType === "Agency"?
                                                 <img src={AgencyGridIdentifier}/>:props.accessLevel ===0 && task.accountType === "Partners"?
                                                 <img src={PartnerIconFilter}/>:''}  &nbsp;<span className=''>{task.SWTeamTaskId}</span>

                                                </p>
                                            </div>
                                        </td>
                                        <td>
                                            <p className='text-center mb-0'>{task.priority}</p>
                                        </td>
                                        <td className="cursor-pointer">
                                            <div className="d-flex">

                                                <p
                                                    className="m-0 comment-paragraph"
                                                    onClick={() => handleViewTaskTitle(task.taskTitle)}
                                                >
                                                    {task.taskTitle}
                                                </p>
                                            </div>
                                        </td>
                                        <td style={{ backgroundColor: task.rowColor ? task.rowColor : '' }}>
                                            <>
                                                {/* {task.status ==="Completed"? */}
                                                <p className='mb-0 text-center'>{task.status}</p>
                                           
                                            </>

                                        </td>
                                      
                                        <td>
                                        <>
                                          {task.status === "Signed Off" ? (
                                            <p className="mb-0 text-center">{task.assignedName}</p>
                                          ) : (
                                            <>
                                              {assignedLoading === task.SWTeamTaskId ? (
                                                <p className="mb-0" style={{ color: "#81e94b" }}>
                                                  Updating..
                                                </p>
                                              ) : (
                                                <>
                                                  {/* Case 1: Access Level 0 */}
                                                  {props.accessLevel === 0 ? (
                                                    <select
                                                      className="form-control w-100"
                                                      name="assignedto"
                                                      id="assignedto"
                                                      value={task.accountType !== "Agency" && task.accountType !== "Partners" ? task.assignedTo : ""}
                                                      disabled={task.accountType === "Agency" || task.accountType === "Partners"}
                                                      onChange={(e) => {
                                                        handleSubmitHistory(e, task, "assignedTo");
                                                        setAssingedLoading(task.SWTeamTaskId);
                                                      }}
                                                    >
                                                      {task.accountType !== "Agency" && task.accountType !== "Partners"? (
                                                        <>
                                                          <option disabled value="">
                                                            -- Assigned to --
                                                          </option>
                                                          {props.teamMemberList.map((member) => (
                                                            <option
                                                              key={member.employeeId}
                                                              value={member.employeeId}
                                                              title={member.email}
                                                              selected={member.employeeId === task.assignedTo}
                                                            >
                                                              {member.employeeName}
                                                            </option>
                                                          ))}
                                                        </>
                                                      ) : (
                                                        <option>{task.assignedName}</option>
                                                      )}
                                                    </select>
                                                  ) : props.LoggedUserRole === 3 ? (
                                                    /* Case 2: LoggedUserRole = 3 */
                                                    <select
                                                      className="form-control w-100"
                                                      name="assignedto"
                                                      id="assignedto"
                                                      value={
                                                        task.role !== "Agency User" ||
                                                        task.role !== "Agency Store POC" ||
                                                        task.role !== "Agency Client"
                                                          ? task.assignedTo
                                                          : ""
                                                      }
                                                      disabled={
                                                        task.role === "Agency User" ||
                                                        task.role === "Agency Store POC" ||
                                                        task.role === "Agency Client"
                                                      }
                                                      onChange={(e) => {
                                                        handleSubmitHistory(e, task, "assignedTo");
                                                        setAssingedLoading(task.SWTeamTaskId);
                                                      }}
                                                    >
                                                      {task.role !== "Agency User" &&
                                                      task.role !== "Agency Store POC" &&
                                                      task.role !== "Agency Client" ? (
                                                        <>
                                                          <option disabled value="">
                                                            -- Assigned to --
                                                          </option>
                                                          {getFilteredAgencyMembers(task).map((member) => (
                                                            <option key={member.id} value={member.id} title={member.email}>
                                                              {member.name}
                                                            </option>
                                                          ))}
                                                        </>
                                                      ) : (
                                                        <option>{task.assignedName}</option>
                                                      )}
                                                    </select>
                                                  ) : props.LoggedUserRole === 2 ? (
                                                    /* Case 2: LoggedUserRole = 3 */
                                                    <select
                                                      className="form-control w-100"
                                                      name="assignedto"
                                                      id="assignedto"
                                                      value={
                                                        task.role !== "Store Manager" 
                                                          ? task.assignedTo
                                                          : ""
                                                      }
                                                      disabled={
                                                        task.role === "Store Manager" 
                                                      }
                                                      onChange={(e) => {
                                                        handleSubmitHistory(e, task, "assignedTo");
                                                        setAssingedLoading(task.SWTeamTaskId);
                                                      }}
                                                    >
                                                      {task.role !== "Store Manager" ? (
                                                        <>
                                                          <option disabled value="">
                                                            -- Assigned to --
                                                          </option>
                                                          {getFilteredAgencyMembers(task).map((member) => (
                                                            <option key={member.id} value={member.id} title={member.email}>
                                                              {member.name}
                                                            </option>
                                                          ))}
                                                        </>
                                                      ) : (
                                                        <option>{task.assignedName}</option>
                                                      )}
                                                    </select>
                                                  ) : (
                                                    /* Case 3: Other users → Agency Members (old code) */
                                                    <select
                                                      className="form-control w-100"
                                                      name="assignedto"
                                                      id="assignedto"
                                                      value={task.assignedTo ?task.assignedTo : ""}
                                                      onChange={(e) => {
                                                        handleSubmitHistory(e, task, "assignedTo");
                                                        setAssingedLoading(task.SWTeamTaskId);
                                                      }}
                                                    >
                                                      <option disabled selected value="">
                                                        -- Assigned to --
                                                      </option>
                                                      {getFilteredAgencyMembers(task) &&
                                                        getFilteredAgencyMembers(task).map((member) => (
                                                          <option
                                                            title={member.email}
                                                            key={member.id}
                                                            value={member.id}
                                                            selected={member.id === task.assignedTo}
                                                          >
                                                            {member.name}
                                                          </option>
                                                        ))}
                                                    </select>
                                                  )}
                                                </>
                                              )}
                                            </>
                                          )}
                                        </>
                                      </td>
                                        <td>
                                            <p className='text-center mb-0'>{task.verifiedName}</p>
                                        </td>

                                        <td className='text-center mb-0'>{task.plannedStartDate}</td>
                                        <td className='text-center mb-0'>{task.plannedEndDate}</td>
                                        <td className='text-center mb-0'>{task.createdBy}</td>
                                        <td className='text-center mb-0'>{task.completedAt}</td>
                                        <td className="cursor-pointer">
                                            <div className="d-flex">

                                                <p
                                                    className="m-0 comment-paragraph"
                                                    onClick={() => handleViewReference(task.reference)}
                                                >
                                                    {task.reference}
                                                </p>
                                            </div>
                                        </td>

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </Col>
            <CustomModal
        header={"Task Title"}
        isOpen={openTaskTitle}
        toggle={() => setOpenTaskTitle(!openTaskTitle)}
        size={"md"}
        className='my-task-custom-module'
      >
        <Card className='card-of-problemarea p-2'>
          <Col md={12} >
            <p className=' mt-1'>{taskName}</p>
          </Col>

        </Card>
      </CustomModal>
      <CustomModal
        header={"Reference"}
        isOpen={openReferencePopup}
        toggle={() => setOpenReferencePopup(!openReferencePopup)}
        size={"md"}
        className='my-task-custom-module'
      >
        <Card className='card-of-problemarea p-2'>
          <Col md={12} >
            <p className=' mt-1'>{referenceText}</p>
          </Col>

        </Card>
      </CustomModal>

     
      <CustomModal
        header={<>
          <h6 className='mb-0'>
            {props.accessLevel ===0 && taskData &&taskData.accountType === "Agency"?
                 <img style ={{height:'30px', marginRight:'10px'}}src={AgencyGridIdentifier}/>:props.accessLevel ===0 && taskData &&taskData.accountType === "Partners"?
                 <img style ={{height:'30px', marginRight:'10px'}}src={PartnerIconFilter}/>:''}
                 View Task / <b>Task Id :</b>&nbsp;{taskData && taskData.SWTeamTaskId}&nbsp;
                 {props.accessLevel ===0 && taskData && taskData.accountType === "Agency"?
            <span>
              {taskData && taskData.AccountDetails ? <span>/<b> Agency Name :</b> {taskData.AccountDetails}</span> : '' }
            </span>: ''
          }
          {props.accessLevel ===0 && taskData && taskData.accountType === "Partners"?
            <span>
              {taskData && taskData.AccountDetails ? <span>/<b> Partner Name :</b> {taskData.AccountDetails}</span> : '' }
            </span>: ''
          }
           </h6>

        </>}
        isOpen={props.viewTaskPopup}
        toggle={() => props.setViewTaskPopup(!props.viewTaskPopup)}
        size={"xl"}
        className='my-task-custom-module'
      >
        <>
          <ViewTaskHistory
            store={props.store} setStore={props.setStore}
            action={true}
           
            setViewTaskPopup={props.setViewTaskPopup}
            setAllUsersTasks={props.setAllUsersTasks}
            setAgencyMemberList={props.setAgencyMemberList}
            agencyMemberList={props.agencyMemberList}
            userData={props.userData}
            loggedUserId={props.loggedUserId}
            LoggedUserRole={props.LoggedUserRole}
            alltasksToDisplay={props.alltasksToDisplay}
            teamMemberList={props.teamMemberList}
            statusList={props.taskStatus}
            taskList={props.taskList}
            taskName={taskName}
            viewTaskData={taskData}
            handleCloseCreateTaskPopup={props.handleCloseCreateTaskPopup}
          />
        </>

      </CustomModal>

        </>
    )
}


const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        error: state.loggedUser.error,

    };
};

export default connect(mapStateToProps)(AllUsersTaskData);